import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

export default function SetPassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Supabase puts the session in the URL hash on invite
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" || event === "PASSWORD_RECOVERY") {
        setReady(true);
      }
    });
  }, []);

  async function handleSetPassword(e) {
    e.preventDefault();

    if (password !== confirm) {
      setMessage({ type: "error", text: "Passwords do not match." });
      return;
    }

    if (password.length < 8) {
      setMessage({ type: "error", text: "Password must be at least 8 characters." });
      return;
    }

    setLoading(true);
    setMessage(null);

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setMessage({ type: "error", text: error.message });
    } else {
      setMessage({ type: "success", text: "Password set successfully! Redirecting..." });
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    }

    setLoading(false);
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">👶</div>
          <h1 className="login-title">Welcome to Staley Family Photos</h1>
          <p className="login-subtitle">Please set a password for your account</p>
        </div>

        {!ready ? (
          <div className="loading-screen" style={{ height: "auto", padding: "24px 0" }}>
            <div className="spinner" />
            <p>Setting up your account...</p>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSetPassword}>
            {message && (
              <div className={message.type === "success" ? "message-success" : "error-banner"}>
                {message.type === "success" ? "✅" : "⚠️"} {message.text}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="Minimum 8 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="Re-enter your password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={8}
              />
            </div>

            <div className="password-rules">
              <p>Password must be at least 8 characters</p>
            </div>

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? "Setting password..." : "Set Password & Enter Site"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
